import { updateDataNode } from '@/endpoints'
import { StructureDetailDto,StructureObjectDto } from '@/endpoints/models'
import { ReadMappingData } from '@/endpoints/schemas'
import { apiCallAction, AppDispatch, UpdateDeepPartial } from '@/store/utils'
import { assignCollectionOrder } from '@/utils/collectionOrder'
import { InitDataParams } from '@/utils/structureType/useStructureTypeActions'

import { loadNodeOrHistoryVersion } from '../node/utils'
import {
	MAPPING_READ_INIT,
	MAPPING_READ_SAVE,
	MAPPING_READ_SELECT_TAB,
	MAPPING_READ_UPDATE,
} from './constants'
import { ReadMappingDataForm,ReadMappingTab } from './types'

interface InitReadMapping {
	editMode: boolean,
	force: boolean,
	node: StructureDetailDto,
	type: typeof MAPPING_READ_INIT
}

interface SaveReadMapping {
	metadata: {
		node: StructureObjectDto
	},
	payload: void
	type: typeof MAPPING_READ_SAVE
}

interface UpdateReadMapping {
	node: StructureObjectDto,
	type: typeof MAPPING_READ_UPDATE,
	update: UpdateDeepPartial<ReadMappingDataForm>
}

interface SelectReadMappingTab {
	node: StructureObjectDto,
	tab: ReadMappingTab,
	type: typeof MAPPING_READ_SELECT_TAB
}

export const initReadMapping =
	({
		nodeId,
		editMode = false,
		force = false,
		version,
		envId,
	}: InitDataParams) =>
	async (dispatch: AppDispatch) => {
		const node = await loadNodeOrHistoryVersion(nodeId, version, envId)

		dispatch({
			type: MAPPING_READ_INIT,
			node,
			editMode,
			force,
		} as InitReadMapping)
	}

export const updateReadMapping = (
	node: StructureObjectDto,
	update: UpdateDeepPartial<ReadMappingDataForm>,
): Actions => ({
	type: MAPPING_READ_UPDATE,
	node,
	update,
})

export const saveReadMapping = (node: StructureObjectDto) =>
	apiCallAction(
		(getState) => {
			const mapping = getState().readMapping.mappings[node.id]

			if (!mapping) {
				throw new Error(`Saving unopened state ${JSON.stringify(node)}`)
			}

			const formData: ReadMappingData = {
				...mapping.form,
				columns: assignCollectionOrder(
					(mapping.form.columns || []).filter((c) => !!c.columnCode),
				),
				sourceItems: assignCollectionOrder(
					(mapping.form.sourceItems || []).filter((c) => c.id !== -1),
				),
			}

			return updateDataNode(node.id, {
				data: JSON.stringify(formData),
			})
		},
		MAPPING_READ_SAVE,
		{ node },
	)

export const selectReadMappingTab = (
	node: StructureObjectDto,
	tab: ReadMappingTab,
): Actions => ({
	type: MAPPING_READ_SELECT_TAB,
	node,
	tab,
})

export type Actions =
	| InitReadMapping
	| SaveReadMapping
	| UpdateReadMapping
	| SelectReadMappingTab
